const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7398,-2197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_14",
    transform: "matrix(1,0,0,1,7398.1,2197.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(162,147,136)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.229,427.226C841.864,436.199 856.307,452.303 858.425,476.099C863.799,536.491 859.036,650.611 765.634,723.567C716.986,761.566 645.676,781.249 544.898,782.297C248.563,785.379 228.851,786.317 169.787,781.757C140.505,779.496 128.092,752.512 131.832,730.021C134.126,716.225 144.734,706.941 155.178,698.454C187.282,672.362 217.848,659.67 242.929,650.433C175.266,560.526 168.045,407.234 243.102,313.569C291.628,253.014 345.039,226.002 394.383,218.873C514.23,201.558 608.07,249.332 637.238,372.611C652.797,438.369 629.652,522.374 589.427,555.725C556.843,582.741 518.626,594.748 484.27,597.406C422.897,602.154 384.985,590.432 348.293,554.652C313.123,520.356 307.249,445.563 340.23,390.654C358.752,359.817 400.731,334.652 466.566,352.822C512.155,365.403 533.844,431.508 501.908,479.001C465.044,533.823 411.134,514.971 398.567,495.588C385.864,475.996 376.511,418.527 446.689,409.395C394.257,408.132 370.334,449.667 376.342,486.177C382.584,524.108 443.059,571.171 510.092,522.021C582.128,469.204 563.179,359.589 531.492,328.97C506.866,305.174 462.496,281.687 404.619,287.638C364.158,291.799 314.393,312.77 283.22,368.741C263.255,404.588 247.391,451.258 255.735,505.333C265.361,567.722 290.845,596.83 323.282,623.679C341.223,638.53 377.534,658.588 427.967,664.569C484.23,671.243 551.802,660.468 597.467,641.931C688.768,604.867 715.152,515.085 716.749,489.123C718.422,461.929 731.71,441.295 750.226,429.585C743.37,399.227 727.138,363.289 713.238,328.051C708.378,315.729 714.436,301.779 726.758,296.919C739.08,292.058 753.03,298.116 757.89,310.438C772.7,347.985 779.641,385.78 780.878,418.982C783.994,418.642 787.153,418.517 790.334,418.6L795.863,418.947C797.425,379.599 804.44,337.841 822.236,304.34C828.45,292.642 842.992,288.19 854.69,294.404C866.388,300.618 870.84,315.16 864.626,326.858C849.305,355.7 832.079,392.801 824.229,427.226Z",
    style: {
      fill: "white"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.339918b5eeee4329320cd05fe5fbb454.svg";
export { ForwardRef as ReactComponent };